import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { getMe, signUp } from '../api';

interface LoginSignupProps {
  setIsLoggedIn: (isLoggedIn: boolean) => void;
  setToken: (token: string) => void;
}

const LoginSignup: React.FC<LoginSignupProps> = ({ setIsLoggedIn, setToken }) => {
  const [email, setEmail] = useState('mikerjacobi+19@gmail.com');
  const [password, setPassword] = useState('test123');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setToken(token);
      setIsLoggedIn(true);
      navigate('/');
    }
  }, []);

  const handleLogin = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const firebaseToken = await userCredential.user.getIdToken();
      localStorage.setItem('token', firebaseToken); // Save token to localStorage
      const me = await getMe(firebaseToken);
      setIsLoggedIn(true);
      setToken(firebaseToken);
      navigate('/');
    } catch (error) {
      console.error("Error logging in:", error);
      setError("Failed to log in. Please check your email and password.");
    }
  };

  const handleSignup = async () => {
    try {
      const firebaseUser = await createUserWithEmailAndPassword(auth, email, password);
      const firebaseToken = await firebaseUser.user.getIdToken();
      localStorage.setItem('token', firebaseToken); // Save token to localStorage
      await signUp(firebaseToken);
      setIsLoggedIn(true);
      setToken(firebaseToken);
      navigate('/');
    } catch (error) {
      console.error("Error signing up:", error);
      setError("Failed to sign up. Please try again.");
    }
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 8 }}>
      <Typography variant="h5" gutterBottom>
        Login or Signup
      </Typography>
      {error && (
        <Typography color="error" gutterBottom>
          {error}
        </Typography>
      )}
      <TextField
        label="Email"
        type="email"
        fullWidth
        margin="normal"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        label="Password"
        type="password"
        fullWidth
        margin="normal"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={handleSignup}
        sx={{ mt: 2 }}
      >
        Signup
      </Button>
      <Button
        variant="outlined"
        color="secondary"
        fullWidth
        onClick={handleLogin}
        sx={{ mt: 2 }}
      >
        Login
      </Button>
    </Box>
  );
};

export default LoginSignup;